import { useLocales } from '@sevenrooms/locales'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'
import { TimeSlotButton, type TimeSlotButtonProps } from '../../TimeSlotButton'

export interface SubmitARequestButtonProps extends Omit<TimeSlotButtonProps, 'data-test'> {
  title?: string
  'data-test'?: string
}

export function SubmitARequestButton({ title, 'data-test': dataTest, ...props }: SubmitARequestButtonProps) {
  const { formatMessage } = useLocales()
  const titleToShow = title || formatMessage(reservationWidgetMessages.resWidgetSubmitRequestButton)
  return (
    <TimeSlotButton data-test={dataTest ?? 'submit-a-request-button'} {...props}>
      {titleToShow}
    </TimeSlotButton>
  )
}
